import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAD6NeGZ2WKtj--oknX2m0yA_1CFQhoeZI",
  authDomain: "creature-quartermaster.firebaseapp.com",
  projectId: "creature-quartermaster",
  storageBucket: "creature-quartermaster.firebasestorage.app",
  messagingSenderId: "670801446466",
  appId: "1:670801446466:web:48983015e6947b59004fdb",
  measurementId: "G-HWKFB800MW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Connect to emulators in development
if (window.location.hostname === "localhost") {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
}

// Discord OAuth Configuration
// IMPORTANT: Sensitive values are loaded from environment variables
// Set these in .env.local for development or in your hosting platform for production
export const discordConfig = {
  clientId: process.env.REACT_APP_DISCORD_CLIENT_ID,
  clientSecret: process.env.REACT_APP_DISCORD_CLIENT_SECRET,
  redirectUri: window.location.hostname === "localhost"
    ? "http://localhost:3000/auth/discord/callback"
    : `https://${window.location.hostname}/auth/discord/callback`,
  scope: "identify email guilds.members.read", // guilds.members.read for role access
  authUrl: "https://discord.com/api/oauth2/authorize",
  tokenUrl: "https://discord.com/api/oauth2/token",
  apiUrl: "https://discord.com/api/users/@me",

  // Discord Server (Guild) for role mapping
  guildId: process.env.REACT_APP_DISCORD_GUILD_ID,

  // Map Discord role IDs to app roles
  // Users with these Discord roles get the corresponding app role
  // Priority: admin > armorer > user (first match wins)
  roleMapping: {
    "1316884594418651169": "admin",        // Discord role ID → app "admin" (C2 role)
    "1466199596274553112": "admin",        // Discord role ID → app "admin"
    "1312590421167313018": "armorer",      // Discord role ID → app "armorer"
    "1312591229170614332": "user",         // Discord role ID → app "user" (badged members)
  },

  // Required role for basic site access - users without this role are denied
  requiredRoleId: process.env.REACT_APP_DISCORD_REQUIRED_ROLE_ID
};

export default app;
